import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { INControl, LogoFull, Profile } from "../../icons";
import { Button } from "../index";
import * as Styled from "./header.style";
import { useInstance } from "../../hooks";

export const Header = () => {
  const instance = useInstance();

  return (
    <Styled.Header className="header">
      <Link to="/">
        {instance === "felix" && (
          <img
            src="/images/felix/felix-white.png"
            width="100"
            alt="felix logo"
          />
        )}
        {instance === "in-control" && <INControl />}
        {instance === "rokit" && (
          <img src="/images/rokit-logo.png" width="120" alt="rokit logo" />
        )}
        {!instance && <LogoFull />}
      </Link>
      <Button variant="secondary" className="with_icon" icon={<Profile />}>
        Contact Support
      </Button>
    </Styled.Header>
  );
};

export default Header;
